import { allFieldsValidationCommon } from "../Validation";

const rules = {
    //licenseSuspendedRevokedFiveYears: 'required',
    sr22: 'required',
    //accidentsViolations: 'required'
};

export const allFieldsValidation = (data) => {
    return allFieldsValidationCommon(data, rules);
};